<template>
  <div>Something seems off , you will be redirected in {{ countDown }} seconds.</div>
</template>

<script>
import Home from "@/views/Home";
export default {
  name: "PageNotFound",
  data() {
    return {
      countDown: 5
    };
  },
  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$router.push("/");
      }
    }
  },
  created() {
    this.countDownTimer();
  }
};
</script>

<style>
</style>
